/* Luxusbetten24 – Konfigurator-Landingpage
   Kein Framework nötig. Funktioniert mit einem oder mehreren Videos (Tabs optional). Initialisiert sich selbst für alle [data-lbk-theater] und [data-lbk-toggle]
   und funktioniert auch im Shopify-Theme-Editor (shopify:section:load). */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ICON = {
    play: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.6-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5Z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>',
    muted: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z"/><path d="m22 9-6 6M16 9l6 6"/></svg>',
    sound: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a10 10 0 0 1 0 14"/></svg>'
  };

  function initTheater(root) {
    if (root.__lbk) return; root.__lbk = true;
    var dataEl = root.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var DATA; try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var keys = Object.keys(DATA);
    var video = root.querySelector('video');
    var tabs = root.querySelectorAll('[data-lbk-tab]');
    var list = root.querySelector('[data-lbk-chapters]');
    var nowN = root.querySelector('[data-lbk-now-n]'), nowT = root.querySelector('[data-lbk-now-t]'), nowX = root.querySelector('[data-lbk-now-x]');
    var btnPlay = root.querySelector('[data-lbk-play]'), btnSound = root.querySelector('[data-lbk-sound]');
    var cur = null, chapters = [], bars = [], active = -1, inView = false, userPaused = reduceMotion;

    function fmtN(i) { return (i + 1) + ' / ' + chapters.length; }
    function setNow(i) {
      if (i === active) return; active = i;
      var c = chapters[i] || chapters[0];
      if (!c) return;
      nowN.textContent = fmtN(Math.max(0, i)); nowT.textContent = c.title; nowX.textContent = c.text || '';
      bars.forEach(function (b, k) { b.btn.setAttribute('aria-current', k === i ? 'step' : 'false'); });
    }
    function build(key) {
      cur = key; var d = DATA[key]; chapters = d.chapters || []; bars = []; active = -1;
      list.innerHTML = '';
      var dur = d.duration || (chapters.length ? chapters[chapters.length - 1].t + 8 : 60);
      chapters.forEach(function (c, i) {
        var end = i + 1 < chapters.length ? chapters[i + 1].t : dur;
        c.end = end;
        var li = document.createElement('li'); li.style.setProperty('--w', Math.max(1, end - c.t).toFixed(2));
        var b = document.createElement('button'); b.type = 'button';
        b.innerHTML = '<span class="lbk-bar"><i></i></span><span class="lbk-vh"></span>';
        b.querySelector('.lbk-vh').textContent = 'Kapitel ' + (i + 1) + ': ' + c.title;
        b.addEventListener('click', function () { video.currentTime = c.t + 0.01; userPaused = false; play(); setNow(i); });
        li.appendChild(b); list.appendChild(li); bars.push({ btn: b, fill: b.querySelector('i'), c: c });
      });
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-lbk-tab') === key ? 'true' : 'false'); });
      video.poster = d.poster || '';
      video.src = d.src;
      video.load();
      setNow(0);
      if (inView && !userPaused) play();
    }
    function play() { var p = video.play(); if (p && p.catch) p.catch(function () { updatePlayBtn(); }); updatePlayBtn(); }
    function updatePlayBtn() {
      var paused = video.paused;
      btnPlay.innerHTML = paused ? ICON.play : ICON.pause;
      btnPlay.setAttribute('aria-label', paused ? 'Video abspielen' : 'Video pausieren');
    }
    function updateSoundBtn() {
      btnSound.innerHTML = video.muted ? ICON.muted : ICON.sound;
      btnSound.setAttribute('aria-label', video.muted ? 'Ton einschalten' : 'Ton ausschalten');
    }
    video.addEventListener('timeupdate', function () {
      var t = video.currentTime, idx = 0;
      for (var i = 0; i < chapters.length; i++) if (t >= chapters[i].t) idx = i;
      bars.forEach(function (b, k) {
        var p = t >= b.c.end ? 1 : t <= b.c.t ? 0 : (t - b.c.t) / (b.c.end - b.c.t);
        b.fill.style.width = (p * 100).toFixed(1) + '%';
      });
      if (t < (chapters[0] ? chapters[0].t : 0)) idx = 0;
      setNow(idx);
    });
    video.addEventListener('play', updatePlayBtn);
    video.addEventListener('pause', updatePlayBtn);
    video.addEventListener('ended', function () {
      // nach dem Ende automatisch zum anderen Bett wechseln
      var next = keys[(keys.indexOf(cur) + 1) % keys.length];
      if (next !== cur) build(next); else { video.currentTime = 0; play(); }
    });
    btnPlay.addEventListener('click', function () { if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); } });
    btnSound.addEventListener('click', function () { video.muted = !video.muted; updateSoundBtn(); if (!video.muted && video.paused) { userPaused = false; play(); } });
    tabs.forEach(function (t) { t.addEventListener('click', function () { userPaused = false; build(t.getAttribute('data-lbk-tab')); }); });
    // Tastatur: Pfeiltasten zwischen den Tabs
    var tl = root.querySelector('[role="tablist"]');
    if (tl) tl.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var i = keys.indexOf(cur) + (e.key === 'ArrowRight' ? 1 : -1); i = (i + keys.length) % keys.length;
      build(keys[i]); tabs[i].focus();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { inView = e.isIntersecting; if (inView && !userPaused) play(); else if (!inView) video.pause(); });
      }, { threshold: 0.35 }).observe(video);
    } else { inView = true; }

    video.muted = true; video.playsInline = true;
    updateSoundBtn();
    build(root.getAttribute('data-lbk-start') || keys[0]);
    updatePlayBtn();
  }

  function initToggle(btn) {
    if (btn.__lbk) return; btn.__lbk = true;
    var media = btn.closest('[data-lbk-media]');
    btn.addEventListener('click', function () {
      var on = btn.getAttribute('aria-pressed') !== 'true';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      media.classList.toggle('is-on', on);
      var l = btn.querySelector('[data-lbk-label]');
      if (l) l.textContent = on ? btn.getAttribute('data-on') : btn.getAttribute('data-off');
    });
  }

  function initScroller(root) {
    if (root.__lbk) return; root.__lbk = true;
    var track = root.querySelector('[data-lbk-track]');
    root.querySelectorAll('[data-lbk-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        var item = track.querySelector('li'); var step = item ? item.getBoundingClientRect().width + 20 : 320;
        track.scrollBy({ left: step * +b.getAttribute('data-lbk-dir'), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lbk-theater]').forEach(initTheater);
    (scope || document).querySelectorAll('[data-lbk-toggle]').forEach(initToggle);
    (scope || document).querySelectorAll('[data-lbk-scroller]').forEach(initScroller);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
